import { motion } from "framer-motion";
import { FileText, Wand2, Layers3, Smartphone } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const STEP_META = [
  { n: "01", icon: FileText, accent: "#E6007E" },
  { n: "02", icon: Wand2, accent: "#F7941D" },
  { n: "03", icon: Layers3, accent: "#8BC53F" },
  { n: "04", icon: Smartphone, accent: "#00A6E6" },
];

export default function HowItWorks() {
  const { t, lang } = useLanguage();
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative py-32 md:py-40 border-t border-white/5"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[500px] rounded-full bg-[#6E2C9A]/10 blur-[160px] pointer-events-none" />

      <div className="mx-auto max-w-7xl px-6 md:px-10 relative">
        <div className="max-w-2xl mb-20">
          <p className="text-xs tracking-[0.22em] uppercase text-[#00A6E6] mb-4">{t.how.kicker}</p>
          <h2 className="font-display text-4xl md:text-6xl font-light tracking-tighter text-balance">
            {lang === "ar" ? (
              <>من <span className="italic">ملفٍ ثابت</span> إلى عددٍ نابض بالحياة.</>
            ) : (
              <>From <span className="italic">flat file</span> to living issue.</>
            )}
          </h2>
          <p className="mt-6 text-zinc-400 text-lg leading-relaxed">
            {t.how.sub}
          </p>
        </div>

        <ol className="relative grid gap-10 md:gap-6 md:grid-cols-4">
          {/* horizontal connector line desktop */}
          <div
            className="hidden md:block absolute top-16 left-[10%] right-[10%] h-px"
            style={{
              background:
                "linear-gradient(to right, transparent, rgba(230,0,126,0.4), rgba(247,148,29,0.4), rgba(139,197,63,0.4), rgba(0,166,230,0.4), transparent)",
            }}
          />

          {t.how.steps.map((s, i) => {
            const meta = STEP_META[i];
            const Icon = meta.icon;
            return (
              <motion.li
                key={meta.n}
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                data-testid={`how-step-${i}`}
                className="relative"
              >
                <div
                  className="relative z-10 mb-6 h-14 w-14 rounded-2xl glass flex items-center justify-center"
                  style={{ color: meta.accent, boxShadow: `0 0 40px ${meta.accent}22` }}
                >
                  <Icon size={22} />
                </div>
                <span
                  className="font-display text-6xl font-light block mb-2"
                  style={{ color: meta.accent, opacity: 0.85 }}
                >
                  {meta.n}
                </span>
                <h3 className="font-display text-2xl tracking-tight mb-2">{s.title}</h3>
                <p className="text-zinc-400 leading-relaxed text-sm">{s.body}</p>
              </motion.li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
